import React from "react";

const sampleVitals = {
  BP: "120/80",
  Pulse: "78",
  Temp: "98.4°F",
  O2: "97%",
};

const medications = [
  { name: "Paracetamol", dosage: "500mg", time: "09:00 AM" },
  { name: "Amoxicillin", dosage: "250mg", time: "01:00 PM" },
];

const nursingNotes = [
  { shift: "Morning", note: "Patient stable, on IV fluids.", nurse: "Nurse A" },
  { shift: "Evening", note: "Temp mildly raised, observed.", nurse: "Nurse B" },
];

const labTests = [
  { test: "CBC", requested: true, result: "Normal", date: "2025-10-27" },
  { test: "Liver Function", requested: false, result: "", date: "" },
];

const rounds = [
  { date: "2025-10-27", time: "10:00 AM", doctor: "Dr. Smith", observations: "Vitals within range." },
];

const dietPlan = { present: true, details: "Low salt, diabetic friendly." };
const specialInstructions = "Maintain isolation, use PPE, observe for infection signs.";

// Sample patient data
const patientInfo = {
  name: "John Doe",
  age: 45,
  gender: "Male",
  id: "P001234",
  room: "ICU-12",
  admissionDate: "2025-10-25",
  diagnosis: "Post-operative care",
  doctor: "Dr. Sarah Wilson",
  bloodType: "O+",
  wardno: "A23",
  allergies: "Penicillin, Latex"
};

function CareTrackingScreen() {
  return (
    <>
      <style>
        {`
          /* --- General --- */
          .care-container {
            width: 100%;
            margin: 0 auto;
            padding: 20px;
            color: #2c503eff;
          }
          
          h2.care-header {
            text-align: start;
            margin-bottom: 36px;
            font-weight: 700;
            color: #000;
            letter-spacing: 0.03em;
            font-size: 24px;
          }

          /* --- Layout --- */
          .main-layout {
            display: flex;
            gap: 24px;
            margin-bottom: 32px;
          }

          .left-section {
            flex: 1;
            max-width: 350px;
          }

          .right-section {
            flex: 2;
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .right-cards-row {
            gap: 20px;
          }

          .right-card {
            flex: 1;
            background: white;
            padding: 20px;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
            border: 1px solid #e5e7eb;
          }

          /* --- Patient Details Card --- */
          .patient-card {
            background: linear-gradient(145deg, #f8faff, #eef4ff);
            padding: 24px;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            border: 1px solid #d1d5db;
            height: fit-content;
          }

          .patient-name {
            font-size: 1.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 8px;
          }

          .patient-id {
            color: #6b7280;
            font-size: 0.95rem;
            margin-bottom: 16px;
          }

          .patient-details {
            display: grid;
            gap: 12px;
          }

          .detail-row {
            display: flex;
            justify-content: space-between;
            padding: 8px 0;
            border-bottom: 1px solid #e5e7eb;
          }

          .detail-label {
            font-weight: 600;
            color: #374151;
            font-size: 0.9rem;
          }

          .detail-value {
            color: #6b7280;
            font-size: 0.9rem;
            text-align: right;
            max-width: 60%;
          }

          .allergies-warning {
            background: #fef2f2;
            color: #dc2626;
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 0.85rem;
            margin-top: 12px;
            border-left: 3px solid #dc2626;
          }

          /* --- Vitals --- */
          .vitals-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
          }
          
          .vital-card {
            background: linear-gradient(145deg, #e9fff1ff, #d9ffe4ff);
            padding: 18px;
            border-radius: 12px;
            text-align: center;
            box-shadow: 0 2px 6px rgba(0,0,0,0.05);
            transition: all 0.25s ease-in-out;
            cursor: pointer;
          }
          
          .vital-card:hover {
            background: #d4ffe7ff;
            transform: translateY(-3px);
            box-shadow: 0 6px 14px rgba(0, 255, 42, 0.2);
          }
          
          .vital-label {
            font-size: 1.05rem;
            color: #00d97fff;
            font-weight: 500;
            margin-bottom: 6px;
          }
          
          .vital-value {
            font-size: 1.2rem;
            color: #1b2733;
            font-weight: 700;
          }

          /* --- Medication Grid --- */
          .medication-grid {
            display: grid;
            gap: 12px;
          }

          .medication-item {
            background: #f8fafc;
            padding: 14px;
            border-radius: 8px;
            border-left: 4px solid #3b82f6;
            transition: all 0.2s ease;
          }

          .medication-item:hover {
            background: #f1f5f9;
            transform: translateX(4px);
          }

          .med-name {
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 4px;
          }

          .med-details {
            font-size: 0.9rem;
            color: #64748b;
          }

          /* --- Tables --- */
          .scroll-x {
            overflow-x: auto;
            width: 100%;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            background: white;
            border-radius: 8px;
            overflow: hidden;
          }
          
          th, td {
            padding: 10px 14px;
            text-align: left;
            border-bottom: 1px solid #e4e4e4;
          }
          
          thead {
            background: #13b469ff;
            color: white;
          }
          
          .table-hover tbody tr:hover {
            background: #eefff4ff;
            transition: background 0.2s;
          }

          /* --- Sections --- */
          section {
            margin-bottom: 32px;
            padding-bottom: 18px;
            border-bottom: 1px solid #e8e8e8;
          }
          
          .section-header {
            color: #009b46ff;
            font-weight: 600;
            margin-bottom: 16px;
            font-size: 1.25rem;
          }

          .card-header {
            color: #009b46ff;
            font-weight: 600;
            margin-bottom: 16px;
            font-size: 1.1rem;
          }
          
          ul {
            padding-left: 16px;
          }
          
          li {
            margin-bottom: 8px;
          }

          /* --- Doctor Rounds --- */
          .round-log {
            background: #fff8e1;
            padding: 12px 18px;
            border-radius: 10px;
            margin-bottom: 8px;
            box-shadow: 0 2px 6px rgba(255, 211, 77, 0.15);
            transition: transform 0.2s ease;
          }
          
          .round-log:hover {
            transform: translateY(-3px);
          }

          /* --- Special Instructions --- */
          .special {
            background: #ffe4e1;
            padding: 14px;
            border-radius: 10px;
            color: #b94a48;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(185, 74, 72, 0.08);
          }

          /* --- Responsive --- */
          @media (max-width: 1024px) {
            .main-layout {
              flex-direction: column;
            }
            
            .left-section {
              max-width: 100%;
            }
            
            .right-cards-row {
              flex-direction: column;
            }
          }

          @media (max-width: 768px) {
            .vitals-grid {
              grid-template-columns: 1fr;
            }
            
            .care-container {
              padding: 16px;
            }
            
            .main-layout {
              gap: 16px;
            }
            
            .right-cards-row {
              gap: 16px;
            }
          }

          @media (max-width: 600px) {
            h2.care-header {
              font-size: 1.25rem;
            }
            
            .section-header, .card-header {
              font-size: 1.05rem;
            }
            
            .patient-card {
              padding: 16px;
            }
            
            .right-card {
              padding: 16px;
            }
          }
        `}
      </style>

      <div className="care-container">
        <h2 className="care-header">Patient Stay & Care Tracking</h2>

        {/* Main Layout: Patient Card Left, Two Cards Right */}
        <div className="main-layout">
          
          {/* Left Section - Patient Details */}
          <div className="left-section">
            <div className="patient-card">
              <div className="patient-name">{patientInfo.name}</div>
              <div className="patient-id">Patient ID: {patientInfo.id}</div>
              
              <div className="patient-details">
                <div className="detail-row">
                  <span className="detail-label">Age:</span>
                  <span className="detail-value">{patientInfo.age} years</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Gender:</span>
                  <span className="detail-value">{patientInfo.gender}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Room:</span>
                  <span className="detail-value">{patientInfo.room}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Ward:</span>
                  <span className="detail-value">{patientInfo.wardno}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Admission:</span>
                  <span className="detail-value">{patientInfo.admissionDate}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Diagnosis:</span>
                  <span className="detail-value">{patientInfo.diagnosis}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Doctor:</span>
                  <span className="detail-value">{patientInfo.doctor}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Blood Type:</span>
                  <span className="detail-value">{patientInfo.bloodType}</span>
                </div>
              </div>
              
              <div className="allergies-warning">
                <strong>⚠️ Allergies:</strong> {patientInfo.allergies}
              </div>
            </div>
          </div>

          {/* Right Section - Two Cards */}
          <div className="right-section">
            <div className="right-cards-row">
              
              {/* Patient Vitals Card */}
              <div className="right-card">
                <h3 className="card-header">Patient Vitals</h3>
                <div className="vitals-grid">
                  {Object.entries(sampleVitals).map(([label, value]) => (
                    <div className="vital-card" key={label}>
                      <div className="vital-label">{label}</div>
                      <div className="vital-value">{value}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Current Medications Card */}
              <div className="right-card mt-3">
                <h3 className="card-header">Current Medications</h3>
                <div className="medication-grid">
                  {medications.map((med, idx) => (
                    <div className="medication-item" key={idx}>
                      <div className="med-name">{med.name}</div>
                      <div className="med-details">{med.dosage} at {med.time}</div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Nursing Notes & Shift Reports */}
        <section>
          <h3 className="section-header">Nursing Notes & Shift Reports</h3>
          <ul>
            {nursingNotes.map((note, idx) => (
              <li key={idx}>
                <strong>{note.shift}:</strong> {note.note} <em>({note.nurse})</em>
              </li>
            ))}
          </ul>
        </section>

        {/* Lab Test Requests & Results */}
        <section>
          <h3 className="section-header">Lab Tests</h3>
          <div className="scroll-x">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Test</th>
                  <th>Requested</th>
                  <th>Result</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {labTests.map((test, idx) => (
                  <tr key={idx}>
                    <td>{test.test}</td>
                    <td>{test.requested ? "Yes" : "No"}</td>
                    <td>{test.result || "-"}</td>
                    <td>{test.date || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Doctor Rounds Log */}
        <section>
          <h3 className="section-header">Doctor Rounds Log</h3>
          {rounds.map((r, idx) => (
            <div className="round-log" key={idx}>
              <strong>
                {r.date} {r.time}
              </strong>{" "}
              - <span>{r.doctor}</span>
              <div>{r.observations}</div>
            </div>
          ))}
        </section>

        {/* Diet & Nutrition */}
        {dietPlan.present && (
          <section>
            <h3 className="section-header">Diet & Nutrition Plan</h3>
            <div>{dietPlan.details}</div>
          </section>
        )}

        {/* Special Instructions */}
        <section>
          <h3 className="section-header">Special Instructions</h3>
          <div className="special">{specialInstructions}</div>
        </section>
      </div>
    </>
  );
}

export default CareTrackingScreen;
